import React, { useState, useEffect } from 'react';
import { func, object, string } from 'prop-types';
import ShippingRestrictionsModal from '../../ShippingRestrictionsModal/ShippingRestrictionsModal';
import Portal from '@ynap/portal';
import { DeliveryAndReturnsModal } from '../../DeliveryAndReturns';
import SizeChart from '../../SizeChart/SizeChart';
import PriceInformationModal from '../../PriceInformationModal/PriceInformationModal';

const PDPOverlay = (props) => {
    const [content, setContent] = useState('');
    const {
        actionsErrors,
        changeSelectedSku,
        config,
        country,
        designerName,
        frontImage,
        language,
        langISO,
        locale,
        masterCategory,
        messages,
        name,
        safeTrackEvent,
        setModal,
        sizeAndFitInformation,
        sizeMeasurement,
        sizeConversion,
        sizeConversionBySku,
        sizeLabel,
        skus,
        trackSizeAndFitSizeSelect,
        trackSizeGuide,
        urlCustomerReturns,
        measurementType,
        sizeScheme,
        isEip,
    } = props;

    useEffect(() => {
        setContent(props.content);
    }, [props.content]);

    const omnibusMessageConfig = config?.head?.omnibusMessageConfig;

    return (
        <Portal show={content}>
            <ShippingRestrictionsModal
                key="shippingRestrictions"
                errors={actionsErrors}
                urlConfig={config?.global?.urlConfig}
                brandId={config.global.application.brandId}
                baseUrl={config.global.services.content.baseUrl}
                coreMediaLocale={langISO}
                clientId={config.global.services.content.clientId}
                country={country}
                language={language}
                closeModal={setModal}
            />
            <DeliveryAndReturnsModal
                key="deliveryAndReturns"
                data-testid="DeliveryAndReturnsModal"
                closeModal={setModal}
                config={{
                    brandId: config.global.application.brandId,
                    baseUrl: config.global.services.content.baseUrl,
                    clientId: config.global.services.content.clientId,
                    urlCustomerReturns,
                    country,
                    language,
                }}
                messages={{ deliveryAndReturns: messages.deliveryAndReturns, error: messages.error, considered: messages.considered }}
                locale={locale}
            />
            <SizeChart
                key="sizeChart"
                measurementType={measurementType}
                data-testid="SizeChartModal"
                sizeAndFitInformation={sizeAndFitInformation}
                sizeMeasurement={sizeMeasurement}
                sizeConversion={sizeConversion}
                sizeConversionBySku={sizeConversionBySku}
                messages={messages}
                masterCategory={masterCategory}
                name={name}
                designerName={designerName}
                image={frontImage}
                closeModal={setModal}
                skus={skus}
                sizeScheme={sizeScheme}
                onOpen={() => safeTrackEvent(trackSizeGuide)}
                changeSelectedSku={(sizeSku, sizeLabel) => {
                    safeTrackEvent(trackSizeAndFitSizeSelect);
                    changeSelectedSku(sizeSku, sizeLabel);
                }}
                selectedSku={sizeLabel}
                // className={bem('sizeGuide')}
                errors={actionsErrors}
                safeTrackEvent={safeTrackEvent}
                isEip={isEip}
            />
            <PriceInformationModal
                key="priceInformation"
                closeModal={setModal}
                data-testid="PriceInformationModal"
                messages={messages}
                locale={`${language?.toLowerCase()}-${country?.toLowerCase()}`}
                termsAndConditionsPath={config?.head?.pdp?.termsAndConditionsPath}
                omnibusConfig={omnibusMessageConfig}
                {...props}
            />
        </Portal>
    );
};

PDPOverlay.propTypes = {
    actionsErrors: object,
    changeSelectedSku: func,
    config: object,
    country: string,
    designerName: string,
    frontImage: object,
    language: string,
    langISO: string,
    locale: string,
    masterCategory: object,
    messages: object,
    name: string,
    safeTrackEvent: func,
    setModal: func,
    sizeAndFitInformation: object,
    sizeMeasurement: object,
    sizeConversion: object,
    sizeLabel: string,
    skus: object,
    trackSizeAndFitSizeSelect: func,
    trackSizeGuide: func,
    urlCustomerReturns: string,
    content: string,
    product: object,
};

export default PDPOverlay;
